<template>
  <b-modal
    id="modal-cancel-refund"
    :title="modalData.title"
    size="lg"
    hide-footer
    scrollable
  >
    <div v-html="modalData.content" />
  </b-modal>
</template>
<script>
import { BModal } from 'bootstrap-vue'

export default {
  name: 'CancelRefundModal',
  components: {
    BModal,
  },
  computed: {
    modalData() {
      return this.$store.getters['contents/dataItem']('2')
    },
  },
  created() {
    this.getContent()
  },
  methods: {
    getContent() {
      this.$store.dispatch('contents/getDataItem', '2')
    },
  },
}
</script>
